import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleChevronUp, faCircleChevronDown } from '@fortawesome/free-solid-svg-icons';
import DefaultAvatar from '../assets/defaultAvatar.png';

const CommentsTab = ({ courseDetails, user, handleCreateComment, handleCommentChange, newComment, replyMessage, handleReplySubmit, handleReplyChange, toggleReply, replyToCommentUid }) => {
    return (
        <div id="comments-list">
            <div style={{ background: 'none' }}>
                <p style={{ textAlign: 'left', fontSize: '1.4vw', margin: 0, fontWeight: 'bold' }}>สอบถาม</p>
                {/* comment post */}
                <div style={{ backgroundColor: '#f2f2f2', border: '1px solid #dddddd', padding: '24px', borderRadius: '16px', boxSizing: 'border-box', margin: '24px 0' }}>
                    {user ? (
                        <div style={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}>
                            <img
                                src={user.image_url ? user.image_url : DefaultAvatar}
                                alt="Profile"
                                style={{ width: '2vw', height: '2vw', borderRadius: '50%', marginRight: '10px' }}
                            />
                            <span>{user.first_name} {user.last_name}</span>
                        </div>
                    ) : (
                        'โปรไฟล์'
                    )}
                    <form onSubmit={handleCreateComment}>
                        <textarea
                            value={newComment}
                            onChange={handleCommentChange}
                            placeholder="ความคิดเห็น..."
                            rows="3"
                            style={{
                                padding: '10px',
                                width: '100%',
                                fontSize: '16px',
                                color: 'black',
                                backgroundColor: 'white',
                                borderRadius: '20px',
                                resize: 'none',
                                border: 'none',
                                boxSizing: 'border-box',
                                fontFamily: 'Kanit, sans-serif',
                                overflow: 'auto',
                                marginTop: '20px'
                            }}
                        />
                        <div style={{ width: '100%', marginTop: '12px' }}>
                            <button type="submit" style={{
                                width: '100%',
                                padding: '10px',
                                backgroundColor: '#44526E',
                                color: '#fff',
                                fontSize: '1vw',
                                border: 'none',
                                borderRadius: '64px',
                                fontFamily: 'Kanit, sans-serif',
                                cursor: 'pointer',
                            }}>
                                โพสต์
                            </button>
                        </div>
                    </form>
                </div>
                <hr />
                <p style={{ textAlign: 'left', fontSize: '1.4vw', marginTop: '20px', fontWeight: 'bold' }}>คำถามทั้งหมด</p>
                {/* comment detail */}
                <ul style={{ listStyleType: 'none', padding: '0' }}>
                    {courseDetails?.comments?.length > 0 ? (
                        courseDetails?.comments?.map((comment) => (
                            <li key={`comment-${comment.uid}`} style={{ marginBottom: '16px', textAlign: 'left', backgroundColor: '#f2f2f2', border: '1px solid #dddddd', padding: '24px', borderRadius: '16px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ width: '95%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={comment.image_url ? comment.image_url : DefaultAvatar}
                                                alt="Profile"
                                                style={{ width: '2vw', height: '2vw', borderRadius: '50%' }}
                                            />
                                            <p style={{ padding: '10px', color: 'black', borderRadius: '20px', boxSizing: 'border-box', whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0, fontSize: '1vw' }}>
                                                {comment.first_name} {comment.last_name}
                                            </p>
                                            <p style={{ color: '#44526e', borderRadius: '20px', boxSizing: 'border-box', whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0, fontSize: '1vw' }}>
                                                - {comment.role === 'admin' ? 'แอดมิน' : comment.role === 'teacher' ? 'อาจารย์' : comment.role === 'student' ? 'นักเรียน' : 'ไม่ระบุ'}
                                            </p>
                                        </div>
                                        <p><span>{comment.message}</span></p>
                                    </div>
                                    <div style={{ display: 'flex', width: '100%' }}>
                                        <button onClick={() => toggleReply(comment.uid)} style={{
                                            width: '100%',
                                            color: '#44526E',
                                            fontSize: '36px',
                                            border: 'none',
                                            fontFamily: 'Kanit, sans-serif',
                                            cursor: 'pointer',
                                            background: 'none',
                                            textAlign: 'right',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-end',
                                        }}>
                                            {replyToCommentUid === comment.uid ? (
                                                <FontAwesomeIcon icon={faCircleChevronUp} style={{ marginBottom: '5px' }} />
                                            ) : (
                                                <FontAwesomeIcon icon={faCircleChevronDown} style={{ marginBottom: '5px' }} />
                                            )}
                                        </button>
                                    </div>
                                </div>

                                {replyToCommentUid === comment.uid && (
                                    <div>
                                        <hr />
                                        <p style={{ textAlign: 'left', fontSize: '1.4vw', marginTop: '20px', fontWeight: 'bold' }}>การตอบกลับ</p>
                                        <div style={{ padding: '0 100px' }}>
                                            <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                {comment.replies.map((reply) => (
                                                    <li key={reply.uid} style={{ marginBottom: '10px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <img
                                                                src={reply.image_url ? reply.image_url : DefaultAvatar}
                                                                alt="Profile"
                                                                style={{ width: '2vw', height: '2vw', borderRadius: '50%' }}
                                                            />
                                                            <p style={{ padding: '10px', color: 'black', borderRadius: '20px', boxSizing: 'border-box', whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0, fontSize: '1vw' }}>
                                                                {reply.first_name} {reply.last_name}
                                                            </p>
                                                            <p style={{ color: '#44526e', borderRadius: '20px', boxSizing: 'border-box', whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0, fontSize: '1vw' }}>
                                                                - {reply.role === 'admin' ? 'แอดมิน' : reply.role === 'teacher' ? 'อาจารย์' : reply.role === 'student' ? 'นักเรียน' : 'ไม่ระบุ'}
                                                            </p>
                                                        </div>
                                                        <p><span>{reply.message}</span></p>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div style={{ marginTop: '10px', background: '#e1e1e1', padding: '10px', borderRadius: '20px', border: '1px solid #cccccc' }}>
                                                <form onSubmit={(e) => handleReplySubmit(e, comment.uid)}>
                                                    <textarea
                                                        value={replyMessage}
                                                        onChange={handleReplyChange}
                                                        rows="3"
                                                        style={{
                                                            padding: '10px',
                                                            width: '100%',
                                                            fontSize: '16px',
                                                            color: 'black',
                                                            backgroundColor: '#F9FAFB',
                                                            borderRadius: '20px',
                                                            resize: 'none',
                                                            border: 'none',
                                                            marginBottom: '10px',
                                                            boxSizing: 'border-box',
                                                            fontFamily: 'Kanit, sans-serif',
                                                        }}
                                                        placeholder="ตอบกลับ..."
                                                    />
                                                    <button type="submit" style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                        backgroundColor: '#44526E',
                                                        color: '#fff',
                                                        fontSize: '1vw',
                                                        border: 'none',
                                                        borderRadius: '64px',
                                                        fontFamily: 'Kanit, sans-serif',
                                                        cursor: 'pointer',
                                                    }}>
                                                        ตอบกลับ
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </li>
                        ))
                    ) : (
                        <p>ไม่มี ความคิดเห็น</p>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default CommentsTab;
